/* eslint-disable no-return-assign */
/* eslint-disable jsx-a11y/label-has-associated-control */
import moment from "moment-business-days";
import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import Dropdown from "react-bootstrap/Dropdown";
import { withRouter } from "react-router";
import DataTable from "react-data-table-component";
import { CardHeader, UncontrolledTooltip, Button, Form } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileCircleCheck, faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import { FilePlus, Download, Plus, Paperclip, X, Share2 } from "react-feather";
import { toast } from "react-toastify";
import DatePicker from "react-datepicker";
import { useDebouncedCallback } from "use-debounce";
import Breadcrumb from "../../components/common/breadcrumb";
import usePaging from "../../hooks/usePaging";
import { humanDateFormat, candidatosKpiIcons } from "../../../config/constants";
import {
  exportCandidatos,
  getAllCandidatos,
  multiAsociateCandidatesNPsMain,
  multiPatchCandidatosNpMain,
  patchCandidatoNpMain,
  postCandidatoNPMain,
  uploadCandidatosMain,
} from "../../services/candidatosNPServices";
import { KPIcard, IconKpi, ContentKpi } from "../../ui/kpis";
import { ButtonSecondary, ButtonPrimary, CustomDropdown, OptionsExportButton } from "../../ui/buttons";
import { tableCustomStylesNP, customActionsLabels } from "../../ui/table";
import { InputCheckboxContainer, InputText } from "../../ui/inputs";
import NewCandidatoFormModal from "../../components/CandidatosNP/newCandidato/newCandidatoNpModal";
import { uploadOrPatchFilesCV } from "../../components/CandidatosNP";
import { handleErrors } from "../../services/handleErrors";
import EditCandidatoFormModal from "../../components/CandidatosNP/editCandidato/editCandidatoNpModal";
import { getEstadoByValue } from "../../components/CandidatosNP/utils";
import { fetchNotasDePedidoActivas, getNotasDePedidoCategory } from "../../services/notasDePedidoServices";
import useFetcher from "../../hooks/useFetcher";
import { BlurSpinner } from "../../components/BlurSpinner";
import MultiEditCandidatoFormModal from "../../components/CandidatosNP/multiSetCandidatos/multiEditCandidatoNpModal";
import { configDatePickerLenguage, handleClickFile } from "../../components/RelevosInfoGeneral/utils";
import ProcesosModal from "./ProcesosModal";
import { ShowSearchBar } from "../../components/SearchBar";
import { useSearchBar } from "../../components/SearchBar/context/SearchBarContext";
import { LabSelect } from "../../components/course/select";
import { CustomLabel } from "../../ui/labels";
import { StylesDatePicker } from "../../ui/stylesDatePicker";
import { getUbicacion } from "../../services/avisosNPServices";
import { RedSwitch, ActionLabel } from "../NotasDePedido";
import MultiAsociateCandidatesNPs from "./MultiAsociateCandidatesNPs";
import { getColorByEstadoCandidate } from "../NotasDePedido/utils";
import ExistingCandidateModal from "../../components/CandidatosNP/existingCandidatoModal";
import KpiCardNP from "../../components/kpiCard/KpiCardNP";
// fetchNotaDePedidoById
const Candidatos = ({ history, location }) => {
  const pagingController = usePaging(getAllCandidatos);
  const { searchBarText } = useSearchBar();
  const locale = configDatePickerLenguage();
  const [categories, isLoadingCategories] = useFetcher(getNotasDePedidoCategory, undefined);
  const [notasDePedidoActivas, isLoadingNotasDePedidoActivas] = useFetcher(fetchNotasDePedidoActivas, undefined);
  const [nuevoCandidatoForm, setNuevoCandidatoForm] = useState(false);
  const [editCandidatoForm, setEditCandidatoForm] = useState(false);
  const [editCandidatoInfo, setEditCandidatoInfo] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [showMultiEditCandidato, setShowMultiEditCandidato] = useState(false);
  const [showMultiAsociateCandidatesNPs, setShowMultiAsociateCandidatesNPs] = useState(false);
  const [toggleCleared, setToggleCleared] = useState(false);
  const [uploadingCandidatos, setUploadingCandidatos] = useState(false);
  const [showProcesosModal, setShowProcesosModal] = useState(false);
  const [procesosModalInfo, setProcesosModalInfo] = useState(null);
  const estadosCat = categories && categories.estadoCandidatoNP;
  const areasDeExperiencia = categories && categories.estadoCandidatoNP ? categories.estadoCandidatoNP : [];
  const provincias = categories && categories.provinciasNP ? categories.provinciasNP : [];
  const [ciudades, isLoadingCiudades] = useFetcher(getUbicacion, [{ provincia: pagingController.query.provincia }]);
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;
  const [params, setParams] = useState(null);
  const [checkMultiProcesos, setCheckMultiProcesos] = useState(false);
  const leidos = pagingController.statusStats && pagingController.statusStats.Leido ? pagingController.statusStats.Leido : 0;

  const [showExistingcandidate, setShowExistingcandidate] = useState(false);
  const [existingCandidateInfo, setExistingCandidateInfo] = useState({});
  const [processToAssociateId, setProcessToAssociateId] = useState(null);

  useEffect(() => {
    if (params) {
      const start = params && params.length > 0 ? params[0].startDate : null;
      const end = params && params.length > 0 ? params[0].endDate : null;

      if (start) {
        pagingController.setFilterValue({ startDate: start, endDate: end });
      }
    } else {
      pagingController.setFilterValue({ startDate: null, endDate: null });
    }
  }, [params]);

  // actualiza el rango de fechas con la query
  useEffect(() => {
    if (pagingController.query && pagingController.query.startDate && pagingController.query.endDate) {
      setDateRange([moment(pagingController.query.startDate, "YYYY/MM/DD").toDate(), moment(pagingController.query.endDate, "YYYY/MM/DD").toDate()]);
    }
  }, []);

  // formatea la fecha para los params
  useEffect(() => {
    if (startDate) {
      setParams([{ startDate, endDate }]);
    }
  }, [startDate, endDate]);

  // formatea el valor del rango de fechas
  const getDataRangeValue = (inputStartDate, inputEndDate) => {
    const start = inputStartDate ? moment(inputStartDate).format("YYYY/MM/DD") : "";
    const end = inputEndDate ? moment(inputEndDate).format("YYYY/MM/DD") : "";
    return `${start} - ${end}`;
  };

  const reloadCandidatosData = () => {
    pagingController.reloadData(history.location);
  };

  useEffect(() => {
    pagingController.setFilterValue({ query: searchBarText });
  }, [searchBarText]);

  const ciudadOptions =
    ciudades && ciudades.ubicacionNP && ciudades.ubicacionNP.length > 0
      ? ciudades.ubicacionNP
          .map((e) => {
            return { label: e.ciudad, value: e.ciudad };
          })
          .sort((a, b) => (a.label > b.label ? 1 : -1))
      : [];

  const provinciaOptions = provincias && provincias.type ? provincias.type : [];

  const areaDeExperienciaOptions =
    areasDeExperiencia && areasDeExperiencia.areaAdministracionLaboral
      ? areasDeExperiencia.areaAdministracionLaboral

          .map((e) => {
            return { label: e.text, value: e.id };
          })
          .sort((a, b) => (a.label > b.label ? 1 : -1))
      : [];

  const niveles = ["Primario", "Secundario", "Terciario", "Universitario"];
  const estados = ["Incompleto", "Completo", "Abandonado"];

  const estudiosAcademicosOptions = [];

  niveles.forEach((nivel) => {
    estados.forEach((estado) => {
      estudiosAcademicosOptions.push({
        label: `${nivel} ${estado}`,
        value: `${nivel} ${estado}`,
      });
    });
  });

  const idiomasLevelOptions = [
    { label: "basico", value: "basico" },
    { label: "intermedio", value: "intermedio" },
    { label: "avanzado", value: "avanzado" },
    { label: "bilingue", value: "bilingue" },
  ];

  const handleReactSelectChange = (selected, options) => {
    if ((options.action === "select-option" && options.option === undefined) || (options.action === "clear" && options.removedValues.length === 1)) {
      const newState = { [options.name]: selected ? selected.value : null };
      if (newState.region) {
        newState.sucursal = null;
      }
      pagingController.setFilterValue(newState);
    } else {
      const newState = { [options.name]: selected[0] ? selected.map((item) => item.value).join(",") : null };
      if (newState.region) {
        newState.sucursal = null;
      }
      pagingController.setFilterValue(newState);
    }
  };

  const handleCreateCandidato = async (candidatoData, files) => {
    try {
      const { message, result } = await postCandidatoNPMain(candidatoData);
      if (files) await uploadOrPatchFilesCV(result.id, files);
      toast.success(message);
      setNuevoCandidatoForm(false);
      reloadCandidatosData();
      return true;
    } catch (error) {
      handleErrors(error, toast.error);
      return false;
    }
  };

  const handleEditCandidatoNpForm = (row) => {
    setEditCandidatoForm(true);
    setEditCandidatoInfo(row);
  };

  const handleEditCandidato = async (candidatoData, files) => {
    try {
      const { message, result } = await patchCandidatoNpMain(candidatoData.id, candidatoData);
      if (files) uploadOrPatchFilesCV(result.id, files);
      toast.success(message);
      setEditCandidatoForm(false);
      reloadCandidatosData();
    } catch (error) {
      handleErrors(error, toast.error);
    }
  };

  const handleMultiEditCandidatos = async (candidatosData) => {
    const { estado } = candidatosData;
    const formattedCandidatosData = candidatosData.idsCandidatos.map((candidato) => {
      return {
        id: candidato,
        estado,
      };
    });
    await multiPatchCandidatosNpMain({ candidatosDetalle: formattedCandidatosData });
    reloadCandidatosData();
    setToggleCleared(!toggleCleared);
  };

  const handleMultiAsociateCandidatesNPs = async (candidatosData) => {
    const { notaDePedidoId } = candidatosData;
    const formattedCandidatosData = candidatosData.idsCandidatos.map((candidato) => {
      return {
        id: candidato,
      };
    });
    try {
      const { message, result, repetidos } = await multiAsociateCandidatesNPsMain({ candidatosDetalle: formattedCandidatosData, notaDePedidoId });
      if (repetidos) {
        toast.warn(message);
        setExistingCandidateInfo(result);
        setShowExistingcandidate(true);
        setProcessToAssociateId(notaDePedidoId);
      } else {
        toast.success(message);
      }
    } catch (error) {
      handleErrors(error, toast.error);
    }

    reloadCandidatosData();
    setToggleCleared(!toggleCleared);
  };

  const handleDownloadCV = async (row) => {
    toast.warn("Descargando CV...");

    await handleClickFile(row.Files[0]);
  };

  const handleUploadFileButton = () => {
    document.getElementById("upExcel").click();
  };
  const handleAddCandidatosFromExcel = async (e) => {
    setUploadingCandidatos(true);
    const selectedFiles = e.target.files;
    try {
      const response = await uploadCandidatosMain({ files: selectedFiles });
      if (response.repetidos) {
        toast.warn(response.message);
        // setExistingCandidateInfo(response.result);
        // setShowExistingcandidate(true);
      } else if (response.error) {
        toast.error(response.message || response.error.message);
      } else {
        toast.success(response.message);
      }
    } catch (error) {
      handleErrors(error, toast.error);
    }

    reloadCandidatosData();
    e.target.value = null;
    setUploadingCandidatos(false);
  };

  const handleMarkAsRead = async (e, row) => {
    const dataToMaskAsRead = {
      id: row.candidato.id,
      leido: e.target.checked,
    };
    await handleEditCandidato(dataToMaskAsRead);
  };

  const handleVerProcesos = (procesos) => {
    setProcesosModalInfo(procesos);
    setShowProcesosModal(!showProcesosModal);
  };

  const handleFilterStatus = (estado) => {
    const currentEstado = pagingController.query.estado;
    const arrayEstado = currentEstado ? currentEstado.split(",") : [];
    const objEstado = estadosCat.type.find((objeto) => objeto.id === estado);
    const estadoId = objEstado ? objEstado.id : null;

    if (currentEstado) {
      // Verificar si el estado actual ya está presente en la lista de estados seleccionados
      const idString = JSON.stringify(estadoId);
      const isEstadoSelected = arrayEstado.includes(idString);

      // Si el estado ya está seleccionado, eliminarlo de la lista
      if (isEstadoSelected) {
        const updatedEstado = arrayEstado.filter((e) => e !== idString);

        if (updatedEstado.length === 0) {
          pagingController.setFilterValue({ estado: null });
        } else {
          pagingController.setFilterValue({ estado: updatedEstado });
        }
      }
      // Si el estado no está seleccionado, agregarlo a la lista
      else {
        const updatedEstado = [...arrayEstado, estadoId];
        pagingController.setFilterValue({ estado: updatedEstado });
      }
    } else {
      // Si no hay estados seleccionados lo agrega directamente
      pagingController.setFilterValue({ estado: estadoId });
    }
  };

  // Busqueda por Nota de Pedido id
  const debouncedSearchNotaDePedido = useDebouncedCallback((value) => {
    if (value) {
      pagingController.setFilterValue({ notaDePedidoId: value });
    } else {
      pagingController.setFilterValue({ notaDePedidoId: null });
    }
  }, 100);

  const searchNotaDePedido = (e) => {
    debouncedSearchNotaDePedido(e.target.value);
  };

  // BOTON EXPORTAR Candidatos
  const downloadCandidatosCSV = async () => {
    toast.success("Su solicitud de exportación está siendo procesada");
    const blob = await exportCandidatos(location.search);
    const link = document.createElement("a");
    const url = window.URL.createObjectURL(blob);
    const filename = `Candidatos-${moment().format(humanDateFormat)}.csv`;
    link.href = url;
    link.setAttribute("download", filename);
    link.click();
    window.URL.revokeObjectURL(url);
  };

  // toggle candidatos multiprocesos
  const handleMultiProcesosFilter = () => {
    setCheckMultiProcesos(!checkMultiProcesos);
    if (!checkMultiProcesos) {
      pagingController.setFilterValue({ multiNP: true });
    } else {
      pagingController.setFilterValue({ multiNP: null });
    }
  };

  useEffect(() => {
    if (pagingController && pagingController.query) {
      const { multiNP } = pagingController.query;
      setCheckMultiProcesos(multiNP);
    }
  }, [pagingController]);

  const handleRowSelected = React.useCallback((state) => {
    setSelectedRows(state.selectedRows);
  }, []);

  const contextComponent = React.useMemo(() => {
    const totalSelected = selectedRows.length;
    return (
      <div className="w-100 d-flex justify-content-between">
        <OptionsExportButton className="border" onClick={() => setToggleCleared(!toggleCleared)}>
          <div className="d-flex align-items-center">
            <p className="my-0 mr-2 bold" style={{ fontFamily: "Nunito", fontSize: "16px" }}>
              {totalSelected > 1 ? `${totalSelected} candidatos seleccionados` : `${totalSelected} candidato seleccionado`}
            </p>
            <X size={16} />
          </div>
        </OptionsExportButton>
        <div className="d-flex align-items-center">
          <ButtonPrimary
            key="asociar-procesos"
            onClick={() => setShowMultiAsociateCandidatesNPs(!showMultiAsociateCandidatesNPs)}
            style={{ backgroundColor: "red" }}
            icon
          >
            Asociar a procesos
          </ButtonPrimary>
          <ButtonPrimary key="cambiar-estado" onClick={() => setShowMultiEditCandidato(!showMultiEditCandidato)} style={{ backgroundColor: "red" }} icon>
            Cambiar estado
          </ButtonPrimary>
        </div>
      </div>
    );
  }, [selectedRows]);

  return (
    <>
      <Helmet>
        <title>PIN - Candidatos</title>
      </Helmet>
      <ShowSearchBar defaultValue={pagingController.query.query} />

      <Breadcrumb title="Candidatos" parent="Sistema de Notas de Pedido" />
      {showExistingcandidate && (
        <ExistingCandidateModal
          isOpen={showExistingcandidate}
          toggle={() => setShowExistingcandidate(!showExistingcandidate)}
          info={existingCandidateInfo}
          notaDePedidoId={processToAssociateId}
          setReloadCandidatos={reloadCandidatosData}
          main
        />
      )}
      {nuevoCandidatoForm && (
        <NewCandidatoFormModal isOpen={nuevoCandidatoForm} toggle={() => setNuevoCandidatoForm(!nuevoCandidatoForm)} handleCreateCandidato={handleCreateCandidato} />
      )}
      {editCandidatoForm && (
        <EditCandidatoFormModal
          info={editCandidatoInfo}
          isOpen={editCandidatoForm}
          toggle={() => {
            setEditCandidatoForm(!editCandidatoForm);
            reloadCandidatosData();
          }}
          handleEditCandidatoNp={handleEditCandidato}
        />
      )}
      {showMultiEditCandidato && (
        <MultiEditCandidatoFormModal
          info={selectedRows}
          isOpen={showMultiEditCandidato}
          toggle={() => setShowMultiEditCandidato(!showMultiEditCandidato)}
          handleMultiEditCandidatos={handleMultiEditCandidatos}
        />
      )}
      {showMultiAsociateCandidatesNPs && (
        <MultiAsociateCandidatesNPs
          info={selectedRows}
          isOpen={showMultiAsociateCandidatesNPs}
          toggle={() => setShowMultiAsociateCandidatesNPs(!showMultiAsociateCandidatesNPs)}
          handleMultiEditCandidatos={handleMultiAsociateCandidatesNPs}
          notasDePedidoActivas={notasDePedidoActivas}
          isLoading={isLoadingNotasDePedidoActivas}
        />
      )}
      {showProcesosModal && (
        <ProcesosModal toggle={() => setShowProcesosModal(!showProcesosModal)} isOpen={showProcesosModal} info={procesosModalInfo} history={history} />
      )}

      <div className="card">
        <div className="card-body">
          <div className="row">
            <CustomDropdown className="col-sm-3 d-flex align-items-end mb-1">
              <Dropdown className="w-100">
                <Dropdown.Toggle
                  className="dropdown-toggle white"
                  id="dropdown-basic"
                  style={{ width: "100%", height: "40px", display: "flex", alignItems: "center", justifyContent: "space-between" }}
                >
                  Perfil
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <div className="col-sm-12 mb-2">
                    <CustomLabel htmlFor="region" className="pt-0 w-100">
                      Estudios
                      <LabSelect
                        border="1px solid #cccccc"
                        borderRadius="5px"
                        id="estudiosAcademicos"
                        name="estudiosAcademicos"
                        className="w-100"
                        onChange={handleReactSelectChange}
                        value={
                          estudiosAcademicosOptions.filter((option) =>
                            pagingController.query.estudiosAcademicos ? pagingController.query.estudiosAcademicos.includes(option.value) : ""
                          ) || null
                        }
                        placeholder="Todo"
                        isClearable
                        options={estudiosAcademicosOptions}
                      />
                    </CustomLabel>
                  </div>

                  <div className="col-sm-12 mb-2">
                    <CustomLabel htmlFor="region" className="pt-0 w-100">
                      Area de experiencia
                      <LabSelect
                        isMulti
                        border="1px solid #cccccc"
                        borderRadius="5px"
                        id="areaDeExperienciaLaboral"
                        name="areaDeExperienciaLaboral"
                        className="w-100"
                        onChange={handleReactSelectChange}
                        value={
                          areaDeExperienciaOptions.filter((option) =>
                            pagingController.query.areaDeExperienciaLaboral ? pagingController.query.areaDeExperienciaLaboral.includes(option.value) : ""
                          ) || null
                        }
                        placeholder="Todo"
                        isClearable
                        isLoading={isLoadingCategories}
                        options={areaDeExperienciaOptions}
                      />
                    </CustomLabel>
                  </div>

                  <div className="col-sm-12 mb-2">
                    <CustomLabel htmlFor="ingles" className="pt-0 w-100">
                      Ingles
                      <LabSelect
                        isMulti
                        border="1px solid #cccccc"
                        borderRadius="5px"
                        id="ingles"
                        name="ingles"
                        className="w-100"
                        onChange={handleReactSelectChange}
                        value={pagingController.query.ingles ? idiomasLevelOptions.filter((option) => pagingController.query.ingles.includes(option.value)) : "" || null}
                        placeholder="Todo"
                        isClearable
                        options={idiomasLevelOptions}
                      />
                    </CustomLabel>
                  </div>

                  <div className="col-sm-12 mb-2">
                    <CustomLabel htmlFor="portugues" className="pt-0 w-100">
                      Portugues
                      <LabSelect
                        isMulti
                        border="1px solid #cccccc"
                        borderRadius="5px"
                        id="portugues"
                        name="portugues"
                        className="w-100"
                        onChange={handleReactSelectChange}
                        value={
                          pagingController.query.portugues ? idiomasLevelOptions.filter((option) => pagingController.query.portugues.includes(option.value)) : "" || null
                        }
                        placeholder="Todo"
                        isClearable
                        options={idiomasLevelOptions}
                      />
                    </CustomLabel>
                  </div>

                  <div className="col-sm-12 mb-2">
                    <CustomLabel htmlFor="frances" className="pt-0 w-100">
                      Francés
                      <LabSelect
                        isMulti
                        border="1px solid #cccccc"
                        borderRadius="5px"
                        id="frances"
                        name="frances"
                        className="w-100"
                        onChange={handleReactSelectChange}
                        value={
                          pagingController.query.frances ? idiomasLevelOptions.filter((option) => pagingController.query.frances.includes(option.value)) : "" || null
                        }
                        placeholder="Todo"
                        isClearable
                        options={idiomasLevelOptions}
                      />
                    </CustomLabel>
                  </div>

                  <div className="col-sm-12 mb-2">
                    <CustomLabel htmlFor="aleman" className="pt-0 w-100">
                      Alemán
                      <LabSelect
                        isMulti
                        border="1px solid #cccccc"
                        borderRadius="5px"
                        id="aleman"
                        name="aleman"
                        className="w-100"
                        onChange={handleReactSelectChange}
                        value={pagingController.query.aleman ? idiomasLevelOptions.filter((option) => pagingController.query.aleman.includes(option.value)) : "" || null}
                        placeholder="Todo"
                        isClearable
                        options={idiomasLevelOptions}
                      />
                    </CustomLabel>
                  </div>

                  <div className="col-sm-12 mb-2">
                    <CustomLabel htmlFor="chino" className="pt-0 w-100">
                      Chino
                      <LabSelect
                        isMulti
                        border="1px solid #cccccc"
                        borderRadius="5px"
                        id="chino"
                        name="chino"
                        className="w-100"
                        onChange={handleReactSelectChange}
                        value={pagingController.query.chino ? idiomasLevelOptions.filter((option) => pagingController.query.chino.includes(option.value)) : "" || null}
                        placeholder="Todo"
                        isClearable
                        options={idiomasLevelOptions}
                      />
                    </CustomLabel>
                  </div>
                </Dropdown.Menu>
              </Dropdown>
            </CustomDropdown>

            <CustomDropdown className="col-sm-3 d-flex align-items-end mb-1">
              <Dropdown className="w-100">
                <Dropdown.Toggle
                  className="dropdown-toggle white"
                  id="dropdown-basic"
                  style={{ width: "100%", height: "40px", display: "flex", alignItems: "center", justifyContent: "space-between" }}
                >
                  Zona
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <div className="col-sm-12 mb-2">
                    <CustomLabel>Provincia</CustomLabel>
                    <LabSelect
                      isMulti
                      id="provincia"
                      name="provincia"
                      className="w-100"
                      onChange={handleReactSelectChange}
                      value={
                        provinciaOptions.filter((option) =>
                          pagingController.query.provincia ? pagingController.query.provincia.split(",").includes(option.value) : ""
                        ) || null
                      }
                      placeholder="Seleccionar"
                      isClearable
                      isLoading={isLoadingCategories}
                      options={provinciaOptions}
                    />
                  </div>

                  <div className="col-sm-12 mb-2">
                    <CustomLabel>Ciudad</CustomLabel>
                    <LabSelect
                      isMulti
                      id="ciudad"
                      name="ciudad"
                      className="w-100"
                      onChange={handleReactSelectChange}
                      value={ciudadOptions.filter((option) => (pagingController.query.ciudad ? pagingController.query.ciudad.includes(option.value) : "")) || null}
                      placeholder="Seleccionar"
                      isClearable
                      isLoading={isLoadingCiudades || isLoadingCategories}
                      isDisabled={ciudadOptions && ciudadOptions.length === 0}
                      options={ciudadOptions}
                    />
                  </div>
                </Dropdown.Menu>
              </Dropdown>
            </CustomDropdown>

            <div className="col-sm-3">
              <CustomLabel htmlFor="notaDePedidoId" className="pt-0 w-100">
                Notas de pedido
                <InputText
                  border="1px solid #cccccc"
                  placeholdercolor="#ccccccc"
                  type="number"
                  id="notaDePedidoId"
                  placeholder="Ingresar ID"
                  value={pagingController.query.notaDePedidoId}
                  onChange={(e) => searchNotaDePedido(e)}
                />
              </CustomLabel>
            </div>

            <div className="col-sm-3">
              <StylesDatePicker border className="mb-1">
                <CustomLabel htmlFor="fechaDePostulacion" className="pt-0 w-100">
                  Fecha de postulación
                  <DatePicker
                    placeholderText="Todo"
                    locale={locale}
                    id="fechaDePostulacion"
                    className="digits date-input"
                    selectsRange
                    startDate={pagingController.query.startDate || startDate}
                    endDate={pagingController.query.endDate || endDate}
                    onChange={(update) => (update ? setDateRange(update) : pagingController.setFilterValue({ startDate: null, endDate: null }))}
                    value={
                      pagingController.query.startDate
                        ? getDataRangeValue(pagingController.query.startDate || startDate, pagingController.query.endDate || endDate)
                        : null
                    }
                    selected={pagingController.query.startDate ? pagingController.query.startDate : null}
                    // monthsShown={!(renderYearContent || renderQuarterContent || renderMonthContent) ? 2 : 1}
                    // showYearPicker={renderYearContent}
                    // showQuarterYearPicker={renderQuarterContent}
                    // showMonthYearPicker={renderMonthContent}
                    isClearable
                    clearButtonClassName="clear-button"
                    autoComplete="off"
                  />
                </CustomLabel>
              </StylesDatePicker>
            </div>
          </div>

          {/* // ------------------------------------------------------------------------------- */}
          {isLoadingCategories ? (
            <></>
          ) : (
            // CARDS DE STATUS
            <div className="my-4">
              <div className="d-flex" style={{ justifyContent: "space-between", gap: "5px" }}>
                {estadosCat && estadosCat.type && pagingController.statusStats ? (
                  estadosCat.type
                    .sort((a, b) => {
                      const order = [1, 7, 2, 3, 4, 5, 6];
                      return order.indexOf(a.id) - order.indexOf(b.id);
                    })
                    .map((estado) => {
                      const statusDef = {
                        id: estado.id,
                        text: estado.text === "Reclutando Preventivamente" ? "Rec. Preventiva" : estado.text,
                        color: getColorByEstadoCandidate(estado.id),
                      };
                      const value = { count: pagingController.statusStats[estado.text] || 0 };
                      value.count = value.count || 0;
                      return (
                        candidatosKpiIcons[estado.id] && (
                          <div style={{ width: "14%" }} key={estado.id}>
                            <KpiCardNP
                              key={estado.id}
                              statusDef={statusDef}
                              icon={candidatosKpiIcons[estado.id]}
                              value={value}
                              total={pagingController.statusStats.Total || 0}
                              onClick={handleFilterStatus}
                              selected={pagingController.query.estado ? pagingController.query.estado.includes(estado.id) : false}
                              NP
                            />
                          </div>
                        )
                      );
                    })
                ) : (
                  <></>
                )}
              </div>
            </div>
          )}

          {/* // ------------------------------------------------------------------------------- */}

          <Form className="p-absolute" style={{ height: "0px", width: "0px", overflow: "hidden" }}>
            <input id="upExcel" type="file" onChange={handleAddCandidatosFromExcel} multiple accept=".xls, .xlsx" />
          </Form>
          <BlurSpinner isLoading={isLoadingCategories || uploadingCandidatos}>
            <div className="mb-0 pt-0  w-100">
              <div className="pb-3 mt-0 pt-0" style={{ overflow: "auto" }}>
                <div className="table-responsive support-table border">
                  <DataTable
                    data={pagingController.data}
                    title={
                      <CardHeader className="pt-1 pb-1 px-0 d-flex align-items-center justify-content-between">
                        <div>{/* Div parte superor izquierda de la tabla */}</div>
                        <div className="d-flex justify-content-center align-items-center pt-0 pb-0">
                          <ActionLabel
                            control={<RedSwitch color="warning" checked={checkMultiProcesos} onChange={handleMultiProcesosFilter} />}
                            label="Varios procesos"
                            style={customActionsLabels}
                          />
                          <KPIcard className="card mb-0 mr-2" style={{ height: "40px" }} borderRadius="4px">
                            <div className="card-body d-flex align-items-center justify-content-between mb-2 pb-0">
                              <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                <IconKpi svgWidth="20px" svgHeight="20px">
                                  <FontAwesomeIcon icon={faFileCircleCheck} />
                                </IconKpi>
                                <ContentKpi>
                                  <h3>Leídos/ Totales</h3>
                                  <div className="d-flex align-items-end justify-content-start">
                                    {pagingController.totalRows ? (
                                      <>
                                        <p>{`${leidos || 0}/ ${pagingController.totalRows || 0}`}</p>
                                      </>
                                    ) : (
                                      <>
                                        <p>-</p>
                                      </>
                                    )}
                                  </div>
                                </ContentKpi>
                              </div>
                            </div>
                          </KPIcard>

                          <ButtonSecondary padding="10px 30px" borderRadius="4px" fontSize="14px" type="button" onClick={handleUploadFileButton}>
                            Importar
                            <span className="m-1 ml-2">
                              <FilePlus size="20" />
                            </span>
                          </ButtonSecondary>

                          <ButtonSecondary
                            padding="10px 30px"
                            borderRadius="4px"
                            fontSize="14px"
                            className="d-flex align-items-center justify-content-center  mr-2"
                            type="button"
                            onClick={() => (window.location.href = "https://adecco-arg.s3.amazonaws.com/TemplateM_Candidatos_AdeccoArg.xlsm")}
                            aria-label="template candidatos"
                          >
                            Template
                            <span className="m-1 ml-2">
                              <Download size="20" />
                            </span>
                          </ButtonSecondary>

                          <ButtonSecondary padding="10px 30px" borderRadius="4px" fontSize="14px" type="button" onClick={(e) => downloadCandidatosCSV(e.target.value)}>
                            Exportar
                            <span className="m-1 ml-2">
                              <Share2 size="20" />
                            </span>
                          </ButtonSecondary>

                          <ButtonSecondary
                            padding="10px 30px"
                            borderRadius="4px"
                            type="button"
                            fontSize="14px"
                            onClick={() => setNuevoCandidatoForm(!nuevoCandidatoForm)}
                          >
                            Candidato
                            <span className="m-1 ml-2">
                              <Plus size="20" />
                            </span>
                          </ButtonSecondary>
                        </div>
                      </CardHeader>
                    }
                    noDataComponent={
                      <div className="p-3">
                        <b>No se encontraron candidatos</b>
                      </div>
                    }
                    onRowClicked={(row) => handleEditCandidatoNpForm(row)}
                    selectableRows
                    onSelectedRowsChange={handleRowSelected}
                    clearSelectedRows={toggleCleared}
                    contextComponent={contextComponent}
                    pagination
                    paginationServer
                    paginationTotalRows={pagingController.totalRows}
                    paginationDefaultPage={parseInt(pagingController.query.page || 1, 10)}
                    onChangeRowsPerPage={pagingController.handleRecordsPerPageChange}
                    paginationPerPage={parseInt(pagingController.query.perpage || 10, 10)}
                    onChangePage={pagingController.handlePageChange}
                    paginationComponentOptions={{ rowsPerPageText: "Candidatos por página", rangeSeparatorText: "de" }}
                    customStyles={tableCustomStylesNP}
                    striped
                    highlightOnHover
                    columns={[
                      {
                        name: "Candidato",
                        selector: (row) => (
                          <>
                            <UncontrolledTooltip trigger="hover" target={`nombre${row.candidatoId}`}>
                              {`${row.candidato.nombre} ${row.candidato.apellido}`}
                            </UncontrolledTooltip>
                            <div data-tag="allowRowEvents" className="mx-2" id={`nombre${row.candidatoId}`}>{`${row.candidato.nombre} ${row.candidato.apellido}`}</div>
                          </>
                        ),

                        center: true,
                        compact: true,
                        sortable: true,
                        style: {
                          cursor: "pointer",
                        },
                      },

                      {
                        name: "Email",
                        selector: (row) => (
                          <>
                            <UncontrolledTooltip trigger="hover" target={`email${row.candidatoId}`}>
                              {row.candidato.email}
                            </UncontrolledTooltip>
                            <div data-tag="allowRowEvents" id={`email${row.candidatoId}`}>
                              {row.candidato.email}
                            </div>
                          </>
                        ),

                        center: true,
                        compact: true,
                        style: {
                          textAlign: "center",
                          cursor: "pointer",
                        },
                      },
                      {
                        name: "Teléfono",
                        selector: (row) => row.candidato.telefono,
                        center: true,
                        compact: true,
                        style: {
                          textAlign: "center",
                          cursor: "pointer",
                        },
                      },
                      {
                        name: "Portal",
                        selector: (row) => row.candidato.portal,
                        center: true,
                        compact: true,
                        // width: "90px",
                        style: {
                          textAlign: "center",
                          cursor: "pointer",
                        },
                      },
                      {
                        name: "Creación",
                        selector: (row) => moment(row.candidato.createdAt).format("DD/MM/YY"),
                        sortable: true,
                        center: true,
                        compact: true,
                        style: {
                          textAlign: "center",
                          cursor: "pointer",
                        },
                      },
                      {
                        name: "Estado",
                        selector: (row) =>
                          row.candidato && row.candidato.estado ? (
                            <>
                              {/* {row.motivo && row.candidato.estado === 6 && (
                          <UncontrolledTooltip placement="top" target={`estado${row.candidatoId}`}>
                            {getMotivoNoAvanza(row.motivo, motivos, row.motivoOtro)}
                          </UncontrolledTooltip>
                        )} */}
                              <p data-tag="allowRowEvents" id={`estado${row.candidatoId}`}>
                                {getEstadoByValue(row.candidato.estado, categories && categories.estadoCandidatoNP && categories.estadoCandidatoNP.type)}
                              </p>
                            </>
                          ) : (
                            ""
                          ),
                        center: true,
                        // compact: true,
                        style: {
                          textAlign: "center",
                          cursor: "pointer",
                        },
                      },
                      {
                        name: "Acción",
                        selector: (row) => (
                          <div style={{ display: "flex", justifyContent: "space-around", flexWrap: "nowrap" }}>
                            {row && row.observaciones !== null && (
                              <>
                                <UncontrolledTooltip placement="top" target={`observaciones${row.candidatoId}`}>
                                  Comentarios
                                </UncontrolledTooltip>
                                <Button
                                  className="px-1"
                                  size="xs"
                                  color="link"
                                  id={`observaciones${row.candidatoId}`}
                                  // onClick={() => {
                                  //   setShowObservaciones(!showObservaciones);
                                  //   setObservaciones(row.observaciones);
                                  // }}
                                >
                                  {/* <Info size="14" color="#293134" /> */}
                                </Button>
                              </>
                            )}

                            <UncontrolledTooltip placement="top" target={`candidatoCV${row.candidatoId}`}>
                              Descargar CV
                            </UncontrolledTooltip>
                            <Button
                              className="px-1"
                              size="xs"
                              color="link"
                              id={`candidatoCV${row.candidatoId}`}
                              onClick={() => handleDownloadCV(row.candidato)}
                              disabled={row.candidato.Files.length === 0}
                            >
                              <Paperclip size="14" color={row.candidato.Files.length === 0 ? "#293134" : "#f0292a"} />
                            </Button>

                            <UncontrolledTooltip placement="top" target={`candidatoProcesos${row.candidatoId}`}>
                              Ver procesos
                            </UncontrolledTooltip>
                            <Button
                              className="px-1"
                              size="xs"
                              color="link"
                              id={`candidatoProcesos${row.candidatoId}`}
                              onClick={() => handleVerProcesos(row)}
                              disabled={row.relsCandidatosNP.length === 0}
                            >
                              <FontAwesomeIcon icon={faPaperPlane} color="#293134" />
                            </Button>

                            <UncontrolledTooltip placement="top" target={`candidatoLeido${row.candidatoId}`}>
                              Marcar como leido
                            </UncontrolledTooltip>
                            <InputCheckboxContainer className="ml-1" id={`candidatoLeido${row.candidatoId}`} checkboxHeight="18px" borderRadius="1px">
                              <div className="checkbox-wrapper-19">
                                <input
                                  type="checkbox"
                                  id={`leido${row.candidatoId}`}
                                  name={`leido${row.candidatoId}`}
                                  onChange={(e) => handleMarkAsRead(e, row)}
                                  checked={row.candidato && row.candidato.leido ? row.candidato.leido : false}
                                />
                                <label htmlFor={`leido${row.candidatoId}`} className="check-box m-0" />
                              </div>
                            </InputCheckboxContainer>
                          </div>
                        ),
                        center: true,
                        compact: true,
                      },
                    ]}
                  />
                </div>
              </div>
            </div>
          </BlurSpinner>
        </div>
      </div>
    </>
  );
};

export default withRouter(Candidatos);
